import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    debug: { type: Boolean, default: false },
    identify: { type: Boolean, default: false },
    email: String,
    firstname: String,
    lastname: String,
    id: String
  }

  connect() {
    const hsq = this.hubSpotQueue

    if (this.shouldIdentify) {
      const identifyEvent = ["identify", this.identifyPayload]
      hsq.push(identifyEvent)
      this.logEvent(identifyEvent)
    }

    const pageViewEvent = ["trackPageView"]
    hsq.push(pageViewEvent)
    this.logEvent(pageViewEvent)
  }

  get hubSpotQueue() {
    window._hsq = window._hsq || []
    return window._hsq
  }

  get shouldIdentify() {
    return this.identifyValue && this.hasEmailValue
  }

  get identifyPayload() {
    const payload = {
      email: this.emailValue,
      firstname: this.firstnameValue,
      lastname: this.lastnameValue
    }

    if (this.hasIdValue) payload.id = this.idValue

    return payload
  }

  get debugEnabled() {
    // Debug can be enabled either from an element value, URL query string,
    // or persisted in localStorage:
    // localStorage.setItem("hubspotIdentifyDebug", "1")
    if (this.debugValue) return true

    if (window.location.search.includes("debug_hubspot_identify=1")) {
      return true
    }

    try {
      return window.localStorage.getItem("hubspotIdentifyDebug") === "1"
    } catch (_error) {
      return false
    }
  }

  logEvent(event) {
    if (!this.debugEnabled) return
    // Logs queued HubSpot events (identify/trackPageView) for manual verification.
    console.log("[hubspot-identify]", event)
  }
}
